import axios from "./axiosInstance";

export const fetchWarehousePermissions = async () => {
  let response = { data: null, error: null };
  try {
    const res = await axios.get(`warehouse/permission/get-all`);
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error };
  }
  return response;
};

export const assignWarehousePermissions = async (data) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.post(
      `warehouse/permission/assign-permissions`,
      data,
    );
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error };
  }
  return response;
};

export const updateWarehousePermissions = async (id, data) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.post(`warehouse/permission/update/${id}`, data);
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error };
  }
  return response;
};

export const fetchWarehouseProductReporting = async (productWarehouseId) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.get(
      `/warehouse/get-product-reporting/${productWarehouseId}`,
    );
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};

export const fetchWarehouseMultiProductReporting = async (data) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.post(`warehouse/get-product-reporting-bulk`, data);
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};

export const fetchOrderCount = async (fromDate, toDate) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.get(
      `/order-overview/order-count?from_date=${fromDate}&to_date=${toDate}`,
    );
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error };
  }
  return response;
};

export const getUserWarehousesByWar_Id = async (id, page, perPage, filter) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.get(
      `userWarehouse/get-user-warehouses/${id}?perPage=${perPage}&page=${page}&filterValue=${filter}`,
    );
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};

export const approveWareHouseRequest = async (id, flag) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.get(`userWarehouse/approve-request/${id}/${flag}`);
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};

export const addGRNByForm = async (data) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.post(`grn`, data);
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};

export const getGRNByID = async (id) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.get(`grn/${id}`);
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};

export const manageWarehouseGRN = async (id, data) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.post(`warehouse/grn/manage-quantity/${id}`, data);
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};

export const editGRNByForm = async (id, data) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.post(`grn/update/${id}`, data);
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};

export const deleteGRN = async (id) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.delete(`grn/${id}`);
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};

export const addCountStock = async (id, data) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.post(`stock-count/create/${id}`, data);
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};

export const updateCountStock = async (id, data) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.post(`stock-count/import-file/${id}`, data);
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};

export const getCountStock = async (page, perPage, filter) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.get(
      `stock-count/get-stock-count?perPage=${perPage}&page=${page}&filterValue=${filter}`,
    );
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};

export const addBrand = async (data) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.post(`product/shipper-brands/store`, data);
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};

export const editBrand = async (id, data) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.post(`product/shipper-brands/update/${id}`, data);
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};

export const getBrandsList = async (page, perPage, filter) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.get(
      `product/shipper-brands/get?perPage=${perPage}&page=${page}&filterValue=${filter}`,
    );
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};

export const deleteBrand = async (id) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.delete(`product/shipper-brands/delete/${id}`);
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};

export const addTransferNote = async (from, to, data) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.post(
      `warehouse/transfer-quantity/${from}/${to}`,
      data,
    );
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};

export const getAllTransferNotesList = async (page, perPage, filter) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.get(
      `warehouse/get-transfer-notes?perPage=${perPage}&page=${page}&filterValue=${filter}`,
    );
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};

export const getWarehouseShippers = async (id) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.get(`warehouse/get-shippers/${id}`);
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};

export const getCategorySubCategoryData = async (id) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.get(`shipper-user/get-data/${id}`);
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};

export const getAllCategoryList = async (page, perPage, filter) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.get(
      `category?perPage=${perPage}&page=${page}&filterValue=${filter}`,
    );
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};

export const addCategory = async (data) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.post(`category/store`, data);
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};

export const deleteCategory = async (id) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.delete(`category/delete/${id}`);
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};

export const updateCategory = async (id, data) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.post(`category/update/${id}`, data);
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};

export const addSubCategory = async (data) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.post(`category/sub-category/create`, data);
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};

export const updateSubCategory = async (id, data) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.post(`category/sub-category/update/${id}`, data);
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};

export const deleteSubCategory = async (id) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.get(`category/sub-category/delete/${id}`);
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};

export const getFulfilmentTierFormula = async (id) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.get(`warehouse/formula/get/${id}`);
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};

export const addFulfilmentTierFormula = async (id, data) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.post(`warehouse/formula/create/${id}`, data);
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};

export const updateFulfilmentTierFormula = async (id, data) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.post(`warehouse/formula/update/${id}`, data);
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};

export const fetchAllWarehouseOrders = async (
  page,
  perPage,
  filter,
  warehouse,
  Nested,
) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.get(
      `order/get-by-warehouse/${warehouse}?perPage=${perPage}&page=${page}&filterValue=${filter}${Nested}`,
    );
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};

export const getAllSuppliersList = async (page, perPage, filter) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.get(
      `supplier/get-paginated?perPage=${perPage}&page=${page}&filterValue=${filter}`,
    );
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};

export const deleteSupplier = async (id) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.delete(`supplier/delete/${id}`);
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};

export const updateSupplier = async (id, data) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.post(`supplier/update/${id}`, data);
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};

export const addSupplier = async (data) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.post(`supplier/create`, data);
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};

export const fetchStockRecNotesHistory = async (grnId) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.get(`/grn/get-notes/${grnId}`);
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};

export const createStockRecNote = async (grnId, data) => {
  let response = { data: null, error: null };
  try {
    const res = await axios.post(`grn/save-grn-notes/${grnId}`, data);
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};
